import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const TransactionsCreate = (props) => (
  <Create {...props} resource="transactions">
    <Form />
  </Create>
);

export default TransactionsCreate;
